<template>
  <div class="section">
    <div class="cursor-pointer flex items-center select-none fill-current text-black" @click="toggle">
      <div class="sub-heading mb-4">Pending campaigns</div>
      <svg-vue
        icon="chevron-up"
        class="h-6 transform transition-all duration-300"
        :class="{ 'rotate-180': showSection }"
      />
    </div>
    <div v-show="showSection">
      <div v-for="(campaign, index) in campaigns" :key="index">
        <a class="text-lg" :href="'/campaigns/' + campaign.slug">
          <div class="md:w-1/3 mb-2 border border-gray-200 bg-gray-100 overflow-hidden p-4 shadow-md">
            {{ campaign.title }}
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PendingCampaigns',
  props: {
    campaigns: [],
  },
  data: () => ({
    showSection: false,
  }),
  methods: {
    toggle() {
      this.showSection = !this.showSection;
    },
  },
};
</script>
